import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { USER_ROLE } from '@app/modules/user/consts/role';
import { Subscription } from 'rxjs';
import { IDropdown } from '@app/shared/interfaces/dropdown';
import { IUser } from '@app/modules/user/interface/user';
import { UserActions } from '@app/modules/user/store/user.actions';
import { Navigate } from '@ngxs/router-plugin';
import { isUserRoleExist } from '@app/shared/helpers/is-user-role-exist';

@Component({ templateUrl: './select-role.component.html' })
export class SelectRolePageComponent implements OnInit, OnDestroy {
  public roles: IDropdown<USER_ROLE>[] = [
    { label: 'Patient', value: USER_ROLE.patient, icon: 'i-10' },
    { label: 'Proxy', value: USER_ROLE.proxy, icon: 'i-16' },
    { label: 'Physician (MD/DO)', value: USER_ROLE.doctor, icon: 'i-5' },
    { label: 'Nurse Practitioner (NP)', value: USER_ROLE.nursePractitioner, icon: 'i-5' },
    { label: 'Physician Assistant (PA)', value: USER_ROLE.physicianAssistant, icon: 'i-5' },
  ];
  public selectedRole: USER_ROLE;
  public placeholder = 'Choose your role';
  private _subscription = new Subscription();

  /**
   * @param store
   */
  constructor(
    private readonly store: Store,
  ) {}

  public ngOnInit(): void {
    this.saveTempUserInStorage();
  }

  public ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  public selectRole(role: USER_ROLE): void {
    this.store.dispatch(new UserActions.UpdateUserInStorage({ role }));
    this.store.dispatch(new Navigate(['/auth/registration']));
  }

  private saveTempUserInStorage(): void {
    const queries = window.location.search
      .slice(1)
      .split('&');

    let user: IUser = {};

    for (const query of queries) {
      const [key, value] = query.split('=');

      if (key === 'invitedAs') {
        if (isUserRoleExist(value)) {
          this.selectedRole = value as USER_ROLE;
          user = { ...user, role: this.selectedRole };
        }
      } else if (value) {
        user[key] = value;
      }
    }

    this.store.dispatch(new UserActions.UpdateUserInStorage(user));
  }
}
